'use client';

import type {ReactNode} from 'react';
import {useEffect, useRef} from 'react';
import {AnimatePresence, motion, useAnimation, useInView} from 'framer-motion';

interface Props {
	children: ReactNode;
	width?: 'fit-content' | '100%';
	margin?: number;
	delay?: number;
}

export const FadeInScroll = ({children, margin = 30, delay = 0}: Props) => {
	const ref = useRef<HTMLDivElement>(null);

	const isInView = useInView(ref, {
		once: true,
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore // FIXME. Framer update.
		margin: `0px 0px -${margin}% 0px`,
	});
	const mainControls = useAnimation();

	useEffect(() => {
		if (isInView) {
			mainControls.start('visible');
		}
	}, [isInView, mainControls]);

	return (
		<div ref={ref} style={{position: 'relative'}}>
			<AnimatePresence>
				<motion.div
					variants={{
						hidden: {opacity: 0, y: -60},
						visible: {opacity: 1, y: 0},
					}}
					initial="hidden"
					animate={mainControls}
					transition={{duration: 0.7, delay}}
					className="h-full"
				>
					{children}
				</motion.div>
			</AnimatePresence>
		</div>
	);
};
